import React from 'react';
import ToggleButtonGroup, { ToggleVariant } from '../../../common/ToggleButtonGroup';
import usePage from '../../../../hooks/use-page';
import { tA11y } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util';

const t = (key: string, options?) => translate('letterBooks', key, options);

const PageViewToggleButton: React.FC = () => {
  const [{ noOfPages, lockForOnePageView }, { setNumberOfPagesDisplayed }] = usePage();

  const toggleItems = [
    {
      value: 1,
      text: t('onePage'),
    },
    {
      value: 2,
      text: t('twoPage'),
    },
  ];

  return (
    <>
      {!lockForOnePageView && (
        <ToggleButtonGroup
          ariaLabel={tA11y('buttons.header')}
          items={toggleItems}
          selectedValue={noOfPages}
          onChange={setNumberOfPagesDisplayed}
          variant={ToggleVariant.secondary}
        />
      )}
    </>
  );
};

export default PageViewToggleButton;
